import moment from "moment";
import { Card, Input } from "reactstrap";
import { DropdownLabel } from "../dropdown/DropdownLabel";
import { purchaseOrdersStatuses, signatureRequiredOptions } from "../../data";
import { saveData } from "../../firebase/utility";
import toast from "react-hot-toast";

const POBasicInformations = ({
  vendor,
  poNumber,
  created_at,
  setVendorPoNumber,
  vendorPoNumber,
  purchaseOrderStatus,
  setPurchaseOrderStatus,
  orderData,
  addressType = "COMMERCIAL",
  setAddressType,
  signatureRequired = "",
  setSignatureRequired,
}) => {
  const currentAddressType = addressType || "COMMERCIAL";
  const isSignatureChecked = Boolean(signatureRequired && signatureRequired.trim() !== "");

  const handleAddressTypeChange = (newType) => {
    if (setAddressType) {
      setAddressType(newType);
    }
    if (orderData?._id) {
      saveData("PurchaseOrders", orderData._id, {
        addressType: newType,
      }).catch((err) => {
        console.error("Error updating addressType:", err);
      });
    }
  };

  const handleSignatureCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    const newSig = isChecked ? (signatureRequired || "DIRECT") : "";
    if (setSignatureRequired) {
      setSignatureRequired(newSig);
    }
    if (orderData?._id) {
      saveData("PurchaseOrders", orderData._id, {
        signatureRequired: newSig,
      }).catch((err) => {
        console.error("Error updating signatureRequired:", err);
      });
    }
  };

  const handleSignatureSelect = (e, value) => {
    const selectedVal = value?.children || value?.value;
    if (setSignatureRequired) {
      setSignatureRequired(selectedVal);
    }
    if (orderData?._id) {
      saveData("PurchaseOrders", orderData._id, {
        signatureRequired: selectedVal,
      }).catch((err) => {
        console.error("Error updating signatureRequired:", err);
      });
    }
  };

  return (
    <Card className="border-1 h-100 rounded-0 bg-secondary-color p-2 p-lg-2 my-lg-0 billingShippingCard">
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="primary-color">PO Basic Info</h5>
      </div>
      <div className="fs-16">
        <div className="d-flex justify-content-between">
          <p className="mb-0">Vendor ID</p>
          <p className="mb-0 primary-color">{vendor?.id ?? ""}</p>
        </div>
        <div className="d-flex justify-content-between">
          <p className="mb-0">Date</p>
          <p className="mb-0 primary-color">
            {moment(created_at).format("MM/DD/YYYY")}
          </p>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <p className="mb-0">PO Number</p>
          <p className="mb-0 primary-color">{poNumber ?? ""}</p>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <p className="mb-0 fw-bold">Vendor PO </p>
          <Input
            style={{ width: "60%", height: "30px" }}
            value={vendorPoNumber}
            type={"text"}
            placeholder="Vendor PO #"
            className="rounded-0"
            onChange={(e) => setVendorPoNumber(e.target.value)}
          />
        </div>
        <DropdownLabel
          customClassName={"inner_style "}
          object_key={"Order"}
          label={"Order Status"}
          placeholder={"Select order status"}
          options={purchaseOrdersStatuses?.map((i) => i.label)}
          value={purchaseOrderStatus ?? ""}
          showSearch
          width="100%"
          style={{ paddingLeft: "unset" }}
          onSelect={(e, value) => {
            let res = purchaseOrdersStatuses[value?.key]?.value;
            setPurchaseOrderStatus(value.children);
            if (orderData?._id) {
              saveData("PurchaseOrders", orderData?._id, {
                purchaseOrderStatus: res,
              });
            } else {
              toast.error("Order ID is missing");
            }
          }}
          className={"drop_down_label_style mb-2 w-100 "}
        />

        {/* Address Type Toggle */}
        <div className="d-flex align-items-center justify-content-between mb-2">
          <p className="mb-0 fw-bold">Address Type</p>
          <div className="btn-group" role="group" aria-label="Address Type">
            <button
              type="button"
              className={`btn btn-sm rounded-0 px-2 py-1 ${
                currentAddressType === "COMMERCIAL"
                  ? "btn-primary text-white"
                  : "btn-outline-secondary bg-white text-dark"
              }`}
              style={{ fontSize: "11px", fontWeight: "600" }}
              onClick={() => handleAddressTypeChange("COMMERCIAL")}
            >
              COMMERCIAL
            </button>
            <button
              type="button"
              className={`btn btn-sm rounded-0 px-2 py-1 ${
                currentAddressType === "RESIDENTIAL"
                  ? "btn-primary text-white"
                  : "btn-outline-secondary bg-white text-dark"
              }`}
              style={{ fontSize: "11px", fontWeight: "600" }}
              onClick={() => handleAddressTypeChange("RESIDENTIAL")}
            >
              RESIDENTIAL
            </button>
          </div>
        </div>

        {/* Signature Required Controls */}
        <div className="pt-2 border-top">
          <div className="d-flex align-items-center mb-2">
            <input
              className="form-check-input me-2 pointer"
              type="checkbox"
              id="signatureRequiredCheck"
              checked={isSignatureChecked}
              onChange={handleSignatureCheckboxChange}
              style={{ cursor: "pointer", width: "16px", height: "16px" }}
            />
            <label
              className="form-check-label mb-0 fw-bold pointer"
              htmlFor="signatureRequiredCheck"
              style={{ fontSize: "13px", cursor: "pointer", userSelect: "none" }}
            >
              Signature Required
            </label>
          </div>

          <DropdownLabel
            customClassName={"inner_style "}
            object_key={"signature"}
            label={"Signature"}
            placeholder={"Select signature"}
            options={signatureRequiredOptions?.map((i) => i.value)}
            value={isSignatureChecked ? (signatureRequired || "DIRECT") : ""}
            disabled={!isSignatureChecked}
            width="100%"
            style={{ paddingLeft: "unset" }}
            onSelect={handleSignatureSelect}
            className={"drop_down_label_style mb-2 w-100 "}
          />
        </div>
      </div>
    </Card>
  );
};

export default POBasicInformations;
